import { Stack } from '@mui/material';
import { useQuery } from 'react-query';

import { assetsApi, tradersApi } from 'api';
import { AssetsTable, TotalBalance } from 'components';
import { AssetsTabs, QueryKey } from 'enums';
import { useCalculateAssetBalances, usePartialQuery, useUser } from 'hooks';

export const TradersBalance: React.FC = () => {
  const { role } = useUser();
  const queryResult = usePartialQuery(
    QueryKey.TradersAssets,
    assetsApi.getAllTradersAsRole(role),
    { paginated: false },
  );
  const { balances } = useCalculateAssetBalances(queryResult.data);

  const tradersQueryResult = useQuery(QueryKey.Traders, () =>
    tradersApi.getAllAsRole(role)(),
  );

  return (
    <Stack spacing={4}>
      <TotalBalance balances={balances} />
      <AssetsTable
        tab={AssetsTabs.TradersBalance}
        traders={tradersQueryResult.data}
        queryResult={queryResult}
      />
    </Stack>
  );
};
